const errors = {
  CREDITOR_AGENT_ERROR: {
    message: 'Transaction stopped due to error at the Creditor Agent',
    error: 'ErrorCreditorAgent',
    errorCode: 'AB09'
  },
  INVALID_CREDITOR_ACCOUNT_NUMBER: {
    message: 'Creditor account number invalid or missing',
    error: 'InvalidCreditorAccountNumber',
    errorCode: 'AC03'
  },
  BLOCKED_ACCOUNT: {
    message: 'Account specified is blocked, prohibiting posting of transactions against it',
    error: 'BlockedAccount',
    errorCode: 'AC06'
  },
  CLOSED_CREDITOR_ACCOUNT_NUMBER: {
    message: 'Creditor account number closed',
    error: 'ClosedCreditorAccountNumber',
    errorCode: 'AC07'
  },
  INVALID_CREDITOR_ACCOUNT_TYPE: {
    message: 'Creditor account type missing or invalid',
    error: 'InvalidCreditorAccountType',
    errorCode: 'AC14'
  },
  TRANSACTION_NOT_SUPPORTED: {
    message: 'Transaction type not supported/authorized on this account',
    error: 'TransactionNotSupported',
    errorCode: 'AG03'
  },
  WRONG_AMOUNT: {
    message: 'Amount received is not the amount agreed or expected',
    error: 'WrongAmount',
    errorCode: 'AM09'
  },
  INCONSISTENT_WITH_END_CUSTOMER: {
    message: 'Identification of end customer is not consistent with associated account number',
    error: 'InconsistenWithEndCustomer',
    errorCode: 'BE01'
  },
  CREDITOR_IDENTIFIER_INCORRECT: {
    message: 'Value in Creditor Identifier is incorrect',
    error: 'CreditorIdentifierIncorrect',
    errorCode: 'CH11'
  },
  ORDER_REJECTED: {
    message: 'The order was rejected by the bank side (for reasons concerning content)',
    error: 'OrderRejected',
    errorCode: 'DS04'
  },
  INVALID_CUTOFF_DATE: {
    message:
      'Associated message, payment information block or transaction was received after agreed processing cut-off date, i.e., date in the past',
    error: 'InvalidCutOffDate',
    errorCode: 'DT05'
  },
  SETTLEMENT_FAILED: {
    message: 'Settlement of the transaction has failed',
    error: 'SettlementFailed',
    errorCode: 'ED05'
  }
};

module.exports = errors;
